function Loading() {
  return (
    <div className="fixed top-[10px] left-[50%] translate-x-[-50%] z-[10000] flex items-center bg-[#fff] border border-[#9d6939] shadow-[inset_0_0_10px_0_#c18753,0_0_5px_1px_#c18753] p-[3px_15px] text-[1.5rem] text-[#000] mx-[10px] uppercase">
      loading
    </div>
  );
}

export default Loading;
